import React, { ReactNode } from 'react'
import { APPLICATION_FEE } from '../../../constant'
import DriverLicense from '../components/DriverLicense'
import PaymentInformation from '../components/PaymentInformation'
import PayStubUpload from '../components/PaystubUpload'

export enum ECompleteScreeningSteps {
  PAYMENT_INFORMATION = 0,
  DRIVER_LICENSE = 1,
  PAYSTUB_UPLOADER = 2
}

export interface ICompleteScreeningStep {
  label: ECompleteScreeningSteps
  content: ReactNode
}

export function getCompleteScreeningSteps(paystubFiles: string[]): ICompleteScreeningStep[] {
  return [
    {
      label: ECompleteScreeningSteps.PAYMENT_INFORMATION,
      content: <PaymentInformation amount={APPLICATION_FEE} />
    },
    {
      label: ECompleteScreeningSteps.DRIVER_LICENSE,
      content: <DriverLicense />
    },
    {
      label: ECompleteScreeningSteps.PAYSTUB_UPLOADER,
      content: <PayStubUpload paystubFiles={paystubFiles} />
    }
  ]
}
